const errorPageRouteName = 'Error'

export default {
  errorPageRouteName,
  passGuardRouteList: [errorPageRouteName, 'SalaryPayout', 'DouyinzsPinPay']
}
